+
<template>
    <div>
        <div class="dashboard-container-small col-np-mobile mb-5">
            <b-card>
                <b-form @submit.stop.prevent="submit">
                    <b-form-group
                        id="input-group-provider"
                        :label="$t('labels.provider')"
                        label-for="input-provider"
                        class="mt-4"
                        label-class="label-align"
                    >
                        <b-form-select
                            class="ml-1 mr-1 rounded-pill"
                            required
                            v-model="authMethod.Provider"
                            :options="providerOptions"
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="input-group-provider-type"
                        :label="$t('labels.authenticationtype')"
                        label-for="input-provider-type"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="provider-type-input-description"
                    >
                        <b-form-radio-group
                            v-model="authMethod.Type"
                            :options="authMethodTypes"
                            class="ml-2"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                        id="input-group-name"
                        :label="$t('labels.name')"
                        label-for="input-name"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="name-input-description"
                    >
                        <b-form-input
                            id="input-name"
                            v-model="authMethod.Name"
                            type="text"
                            required
                            :placeholder="$t('placeholders.entername')"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="title-input-description" class="ml-3">
                            {{ $t('messages.giveitaname') }}
                        </b-form-text>
                    </b-form-group>
                    <b-form-group
                        id="input-group-client-id"
                        :label="$t('labels.clientid')"
                        label-for="input-client-id"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="client-id-input-description"
                    >
                        <b-form-input
                            id="input-client-id"
                            v-model="authMethod.ClientID"
                            type="text"
                            required
                            :placeholder="$t('placeholders.enterclientid')"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="title-input-description" class="ml-3">
                            {{ $t('messages.clientidhelp') }}
                        </b-form-text>
                    </b-form-group>
                    <b-form-group
                        id="input-group-client-secret"
                        :label="$t('labels.clientsecret')"
                        label-for="input-client-secret"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="client-secret-input-description"
                    >
                        <b-form-input
                            id="input-client-secret"
                            v-model="authMethod.ClientSecret"
                            type="text"
                            required
                            :placeholder="$t('placeholders.enterclientsecret')"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="title-input-description" class="ml-3"
                            >{{ $t('messages.clientsecrethelp') }}
                        </b-form-text>
                    </b-form-group>

                    <b-form-group
                        id="input-group-auth-url"
                        :label="$t('labels.authurl')"
                        label-for="input-auth-url"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="auth-url-input-description"
                    >
                        <b-form-input
                            id="input-auth-url"
                            v-model="authMethod.AuthURL"
                            type="text"
                            required
                            :placeholder="$t('placeholders.enterauthurl')"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="title-input-description" class="ml-3"
                            >{{ $t('messages.authurlhelp') }}
                        </b-form-text>
                    </b-form-group>

                    <b-form-group
                        id="input-group-token-url"
                        :label="$t('labels.tokenurl')"
                        label-for="input-token-url"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="token-url-input-description"
                    >
                        <b-form-input
                            id="input-token-url"
                            v-model="authMethod.TokenURL"
                            type="text"
                            required
                            :placeholder="$t('placeholders.entertokenurl')"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="title-input-description" class="ml-3"
                            >{{ $t('messages.tokenurlhelp') }}
                        </b-form-text>
                    </b-form-group>

                    <b-form-group
                        id="input-group-token-url"
                        :label="$t('labels.userinfourl')"
                        label-for="input-token-url"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="user-info-input-description"
                    >
                        <b-form-input
                            id="input-user-info-url"
                            v-model="authMethod.UserInfoURL"
                            type="text"
                            required
                            :placeholder="$t('placeholders.enteruserinfourl')"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="user-info-input-description" class="ml-3"
                            >{{ $t('messages.userinfourlhelp') }}
                        </b-form-text>
                    </b-form-group>

                    <b-form-group
                        id="input-group-redirect-url"
                        :label="$t('labels.redirecturl')"
                        label-for="input-redirect-url"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="redirect-url-input-description"
                    >
                        <b-form-input
                            id="input-redirect-url"
                            v-model="authMethod.RedirectURL"
                            type="text"
                            required
                            readonly
                            @click="copyToClipboard"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="title-input-description" class="ml-3">
                            {{ $t('messages.redirecturlhelp') }}
                        </b-form-text>
                    </b-form-group>

                    <b-form-group
                        id="input-group-scopes"
                        :label="$t('labels.scopes')"
                        label-for="input-scopes"
                        class="mt-4"
                        label-class="label-align"
                        aria-describedby="scopes-input-description"
                    >
                        <b-form-input
                            id="input-scopes"
                            v-model="authMethod.Scopes"
                            type="text"
                            required
                            :placeholder="$t('placeholders.scopeexample')"
                            class="rounded-pill"
                        ></b-form-input>
                        <b-form-text id="title-input-description" class="ml-3"
                            >{{ $t('messages.scopeshelp') }}
                        </b-form-text>
                    </b-form-group>

                    <b-form-group
                        id="input-group-login-cta-title"
                        :label="$t('labels.loginctatitle')"
                        label-for="input-LoginTitle"
                        class="mt-4"
                        label-class="label-align"
                    >
                        <b-form-input
                            id="input-LoginTitle"
                            v-model="authMethod.LoginTitle"
                            type="text"
                            required
                            :placeholder="$t('placeholders.loginctatitle')"
                            class="rounded-pill"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-SignupTitle"
                        :label="$t('labels.signupctatitle')"
                        label-for="input-SignupTitle"
                        class="mt-4"
                        label-class="label-align"
                    >
                        <b-form-input
                            id="input-SignupTitle"
                            v-model="authMethod.SignupTitle"
                            type="text"
                            required
                            :placeholder="$t('placeholders.signupctatitle')"
                            class="rounded-pill"
                        ></b-form-input>
                    </b-form-group>

                    <div class="text-right mt-4">
                        <b-button variant="outline-primary" class="mr-3" @click="cancel">
                            {{ $t('labels.cancel') }}
                        </b-button>
                        <b-button variant="primary" type="submit">
                            {{ isEditing ? $t('labels.save') : $t('labels.create') }}
                        </b-button>
                    </div>
                </b-form>
            </b-card>
        </div>
    </div>
</template>

<script>
import { isNil, get } from 'lodash';
import axios from 'axios';
import EventBus from '../../../../eventBus';

export default {
    name: 'AuthenticationsProviderEditCreate',
    created() {
        this.providerOptions = [
            {
                value: 'CUSTOM',
                text: this.$t('labels.custom'),
            },
        ];
        this.authMethodTypes = [{ item: 'OAUTH2', name: this.$t('labels.oauth2') }];
    },
    mounted() {
        this.authMethod.RedirectURL = `https://${this.$store.state.space.DomainName}/oauth2/exchange`;
        if (this.isEditing) {
            this.fetchAuthMethod();
        } else {
            this.loading = false;
        }
    },
    data() {
        return {
            loading: true,
            providerOptions: [],
            providerDefaultValues: {
                LINKEDIN: {
                    Name: 'Linkedin',
                    AuthURL: 'https://www.linkedin.com/oauth/v2/authorization',
                    TokenURL: 'https://www.linkedin.com/oauth/v2/accessToken',
                    Scopes: 'openid,profile,email',
                    LoginTitle: 'Sign in with Linkedin',
                    SignupTitle: 'Sign up with Linkedin',
                },
            },
            authMethodTypes: [],
            authMethod: {
                Name: '',
                Type: 'OAUTH2', // TODO: change when more types are implemented
                Provider: 'CUSTOM',
                ClientID: '',
                ClientSecret: '',
                AuthURL: '',
                TokenURL: '',
                UserInfoURL: '',
                RedirectURL: '',
                Scopes: '',
            },
        };
    },
    methods: {
        fetchAuthMethod() {
            axios({
                method: 'GET',
                url: `/admin/auth-methods/${this.$route.params.authMethodID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.authMethod = get(response, 'data', this.authMethod);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        createAuthMethod() {
            axios({
                method: 'POST',
                url: '/admin/auth-methods/',
                withCredentials: true,
                data: this.authMethod,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((_) => {
                    this.$router.push({ name: 'AuthenticationsProvidersMenu' });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.authMethodCreateFailed'),
                        Details: error.response.data,
                    });
                });
        },
        updateAuthMethod() {
            axios({
                method: 'PUT',
                url: `/admin/auth-methods/${this.$route.params.authMethodID}`,
                withCredentials: true,
                data: this.authMethod,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((_) => {
                    this.$router.push({ name: 'AuthenticationsProvidersMenu' });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.authMethodUpdateFailed'),
                        Details: error.response.data,
                    });
                });
        },
        cancel() {
            this.$router.push({ name: 'AuthenticationsProvidersMenu' });
        },
        submit() {
            if (this.isEditing) {
                this.updateAuthMethod();
            } else {
                this.createAuthMethod();
            }
        },
        async copyToClipboard() {
            // Select the text inside the input
            const inputElement = document.getElementById('input-redirect-url');
            inputElement.select();

            try {
                // Use the Clipboard API to copy the text
                await navigator.clipboard.writeText(inputElement.value);
                EventBus.$emit('INFO', {
                    Message: this.$t('messages.copiedtoclipboard'),
                    Details: '',
                });
            } catch (err) {
                console.error('Failed to copy URL: ', err);
            }
        },
    },
    computed: {
        isEditing() {
            return !isNil(this.$route.params.authMethodID);
        },
        headerText() {
            return this.isEditing ? 'Edit' : 'Create';
        },
    },
    watch: {
        // if it's not loaded from the store, set the default values
        'authMethod.Provider': function (val) {
            if (val === 'LINKEDIN' && !this.loading) {
                this.authMethod = {
                    ...this.authMethod,
                    ...this.providerDefaultValues[val],
                };
            }
        },
    },
};
</script>

<style scoped></style>
